/**
 * Which media host a case's images live on.
 *
 * The client the user is logged in as and the deployment a page is pointed at
 * are not the same thing. Hegic signs in once, and the break-in detail page
 * shows cases whose images hegicb.media serves while the session still says
 * hegicpp.media. Resolving from the session there builds URLs that 404 —
 * silently, because every <img> involved hides itself onError, so the reviewer
 * sees blank space rather than a broken image.
 *
 * The rule lived in four copied fragments before this; each copy was a place
 * to forget the deployment, and four of them had. It lives here now, and
 * callers take a resolver rather than the deployment itself, so nobody has to
 * re-derive it correctly.
 *
 * React-free on purpose: buildDamageModel is pure and unit-tested, and this
 * test runner resolves neither react-router-dom nor axios.
 */
import { getMediaBaseUrl, getMediaPathPrefix } from "../config/clientConfig";
import { buildMediaUrl } from "./mediaUrl";

/**
 * @param {{mediaBaseUrl?: string, mediaPathPrefix?: string}} [deployment]
 *        the deployment being shown, or nothing for the logged-in client.
 */
export const mediaTargetFor = (deployment) => ({
  baseUrl: deployment?.mediaBaseUrl || getMediaBaseUrl(),
  // "" is an answer here, not a missing value. A `||` chain would fall
  // through and leak the session client's prefix into a deployment's URL.
  pathPrefix: deployment
    ? deployment.mediaPathPrefix || ""
    : getMediaPathPrefix(),
});

/**
 * `(path) => url` for that target.
 *
 * The host is read when the returned function is CALLED, not when it is
 * built, so a resolver cannot go stale across a login.
 */
export const mediaResolverFor = (deployment) => (path) =>
  buildMediaUrl(path, mediaTargetFor(deployment));

export default mediaResolverFor;
